














import { openModal } from 'mycorems-app-shared';
import eventBus from '@/messaging/event-bus';
import { EmailReportGenerated, PricePlanStarted } from '@/messaging/events';
import { HasTaskMixin } from '@/mixins';
import isGranted from '@/auth/isGranted';
import { Client } from '@/types';
import Tooltip from '@/components/Tooltip.vue';
import PickPricePlanModal from './PickPricePlanModal.vue';
import clientRepository from '../account/client/client-repository';

interface Data {
  client: Client|null,
  task: Promise<Client>|null,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      client: null,
      task: null,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    hasActivePlan(): boolean {
      if (!this.client) return false;
      return (this.client.credits !== 0 || (this.client.credits !== this.client.numGenerated));
    },
  },
  methods: {
    open(): void{
      openModal(PickPricePlanModal, {
        accountId: this.accountId,
      });
    },
    load(): void {
      this.task = clientRepository.find(this.accountId);
      this.task.then((client: Client) => {
        this.client = client;
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
    eventBus.$on(PricePlanStarted.eventName, this.load);
    eventBus.$on(EmailReportGenerated.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(PricePlanStarted.eventName, this.load);
    eventBus.$off(EmailReportGenerated.eventName, this.load);
  },
  components: {
    Tooltip,
  },
});
